import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoujjaincabservice() {



  const cardData =
  {
    keyword: 'Pune to Ujjain Cab Service',
    heading: 'Sai Trupti Cabs: Pune to Ujjain Cab Service',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Ujjain cab service designed for long-distance and pilgrimage travel, including Mahakal darshan trips. Choose from well-maintained AC sedans, SUVs, Innova Crysta, and premium vehicles with spacious seating and luggage capacity, all driven by professional, background-verified chauffeurs ensuring safe and smooth journeys. We provide flexible options like one way cab Pune to Ujjain, round trip taxi, and customized tour packages at transparent and affordable fares with no hidden charges. With 24x7 online cab booking, instant confirmation, and dedicated customer support, Sai Trupti Cabs ensures a hassle-free, comfortable, and budget-friendly travel experience from Pune to Ujjain every time.',

    top: 'Top Places to Visit in Ujjain with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Mahakaleshwar Jyotirlinga Temple",
    "description": "Mahakaleshwar Temple is the spiritual heart of Ujjain and one of the twelve sacred Jyotirlingas of Lord Shiva in India. Situated on the banks of the holy Kshipra River, this majestic temple attracts millions of devotees each year. The unique feature of this shrine is the self-manifested (Swayambhu) lingam, believed to draw divine energy from within itself. The famous Bhasma Aarti performed every dawn is a mesmerizing spectacle — where the deity is worshipped with sacred ash amidst chants, drums, and lamps. The temple’s towering spire, intricate carvings, and powerful atmosphere make it one of the most profound experiences in Hindu devotion. Mahakaleshwar isn’t just a temple — it’s the pulsating soul of Ujjain’s faith and mysticism."
  },
  {
    "title": "Shree Kal Bhairav Temple",
    "description": "Kal Bhairav Temple is among Ujjain’s most enigmatic and powerful shrines, dedicated to Lord Kal Bhairav, the fierce manifestation of Lord Shiva. The temple’s origin is traced to the Tantra tradition, and it’s famous for its unique ritual where devotees offer liquor to the deity as part of worship. The ancient idol, adorned with a garland of skulls and flowers, symbolizes the balance of destruction and creation. The fragrance of incense, rhythmic drums, and the sight of flickering diyas add to the temple’s mystical aura. Devotees believe Kal Bhairav protects Ujjain and its pilgrims from all evils. Visiting this temple offers a profound glimpse into the city’s deep spiritual diversity."
  },
  {
    "title": "Ram Ghat (Kshipra River)",
    "description": "Ram Ghat, situated on the banks of the holy Kshipra River, is one of the most sacred bathing ghats in India and the focal point of the grand Kumbh Mela (Simhastha) held every 12 years. Devotees come from far and wide to take a holy dip in its waters, believed to cleanse sins and grant spiritual liberation. At sunrise, the ghats come alive with chants, conch sounds, and the golden glow of diyas floating on the river. The evening aarti transforms the scene into a surreal celebration of faith and light. Surrounded by old temples, ashrams, and pilgrims, Ram Ghat embodies Ujjain’s eternal connection with divinity and purity."
  },
  {
    "title": "Harsiddhi Temple",
    "description": "The Harsiddhi Temple is one of Ujjain’s most revered Shakti Peethas, where Goddess Parvati’s elbow is believed to have fallen. The temple’s striking red towers, golden spire, and twin lamp pillars (Deep Stambhas) create an unforgettable sight, especially when hundreds of lamps are lit during Navratri. The main deity, Harsiddhi Mata, is flanked by idols of Mahalakshmi and Mahasaraswati, symbolizing power, wealth, and wisdom. The temple’s peaceful yet powerful energy attracts both devotees and spiritual seekers. It stands as a beacon of feminine divinity, complementing Ujjain’s masculine power of Lord Mahakal. Visiting Harsiddhi fills the soul with grace, courage, and serenity."
  },
  {
    "title": "Sandipani Ashram",
    "description": "Sandipani Ashram holds great mythological significance as the place where Lord Krishna, along with his brother Balarama and friend Sudama, received education from Guru Sandipani. The ancient gurukul-style ashram, located near the Gomti tank, still radiates simplicity and wisdom. The ashram complex includes shrines dedicated to Krishna, Balarama, and Sudama, along with a sacred pond believed to have been created by Lord Krishna himself. The peaceful environment, chirping birds, and the sound of temple bells make it an ideal place for meditation and reflection. Sandipani Ashram offers visitors a glimpse into India’s ancient educational traditions and divine history."
  },
  {
    "title": "Mangalnath Temple",
    "description": "Perched on a scenic hill overlooking the Kshipra River, Mangalnath Temple is considered the birthplace of Mars (Mangal Graha) according to Hindu astrology. The temple is revered for planetary poojas and Navagraha rituals that devotees perform to overcome astrological challenges. The panoramic view of the river and the city from the temple’s courtyard is breathtaking, especially at sunrise. Priests conduct elaborate rituals with Vedic chants, incense, and offerings that fill the air with positivity. Many pilgrims believe that visiting Mangalnath removes negative planetary influences and brings peace and prosperity. The temple harmoniously blends cosmic energy, nature, and faith."
  },
  {
    "title": "Vikram Kirti Mandir Museum",
    "description": "The Vikram Kirti Mandir Museum, built to honor King Vikramaditya, showcases Ujjain’s glorious past through sculptures, coins, manuscripts, and ancient relics. The museum also houses the Kalidas Academy, dedicated to preserving and promoting classical Sanskrit literature. Visitors can explore galleries that narrate the legend of King Vikramaditya’s wisdom and the city’s role as a seat of learning. Stone inscriptions, ancient tools, and rare art pieces make it a treasure for historians and art lovers. The museum stands as a cultural bridge between Ujjain’s royal heritage and its enduring intellectual spirit. A visit here deepens one’s appreciation for the city’s historic and poetic legacy."
  },
  {
    "title": "Bade Ganeshji Ka Mandir",
    "description": "Situated near the Mahakaleshwar Temple, the Bade Ganeshji Ka Mandir is home to one of the largest idols of Lord Ganesha in India. The colossal statue, crafted with elegance and devotion, is surrounded by sculptures depicting various Hindu deities. The temple also houses a small school where students study astrology and Sanskrit scriptures. The atmosphere here is filled with chants, bell sounds, and a strong sense of peace. Devotees visit before or after Mahakal darshan to seek Lord Ganesha’s blessings for success and wisdom. This temple adds joy and divine charm to Ujjain’s spiritual circuit."
  },
  {
    "title": "Gopal Mandir",
    "description": "Built in the 19th century by Queen Bayaji Bai Shinde, Gopal Mandir is a beautiful marble temple dedicated to Lord Krishna, located in the heart of Ujjain near the city’s main market. The temple’s silver doors, intricate carvings, and gleaming white walls reflect Maratha architectural brilliance. The idol of Lord Krishna here, adorned in colorful garments and ornaments, fills the space with divine radiance. Festivals like Janmashtami are celebrated with grandeur, music, and dance. The temple is not just a place of worship but also a piece of living history connecting devotion and artistry in one frame."
  },
  {
    "title": "Jantar Mantar (Vedh Shala)",
    "description": "Ujjain’s Jantar Mantar, also known as Vedh Shala, is one of India’s oldest observatories built by Raja Jai Singh II in the 18th century. The instruments made of stone and metal were used to measure time, track celestial movements, and study planetary positions. Visitors can see sundials, quadrants, and hemispherical devices still functioning with remarkable precision. The observatory symbolizes India’s ancient expertise in astronomy and mathematics. Standing here, you can imagine sages and scholars gazing at the stars, decoding cosmic rhythms centuries before modern technology. Vedh Shala beautifully merges science, spirituality, and history — capturing Ujjain’s timeless quest for cosmic truth."
  }
],



"services": [
  {
    "name": "Pune to Ujjain Cab Service",
    "description": "Book comfortable Pune to Ujjain cabs for a safe, hassle-free journey. Choose from AC and non-AC vehicles including Sedans, SUVs, and luxury cars. Travel with experienced drivers familiar with long-distance routes, enjoy flexible pickup and drop points, and benefit from transparent pricing. Perfect for family trips, weekend getaways, group travel, or corporate journeys, with easy online booking, instant confirmation, and 24/7 support ensuring a smooth ride."
  },
  {
    "name": "Pune to Ujjain Taxi Service",
    "description": "Hire a Pune to Ujjain taxi for a stress-free and scenic journey. Well-maintained vehicles, courteous drivers, and flexible schedules make it ideal for tourists, business travelers, and families. One-way or round-trip options are available with transparent fare policies."
  },
  {
    "name": "Pune to Ujjain Car Hire",
    "description": "Rent a car from Pune to Ujjain for personalized and comfortable travel. Choose from Sedans, SUVs, and luxury vehicles with AC/non-AC options. Benefit from professional drivers, luggage assistance, flexible routes, and safe travel. Ideal for families, groups, or business trips seeking convenience and comfort."
  },
  {
    "name": "AC Cab Pune to Ujjain",
    "description": "Travel comfortably with AC cab service from Pune to Ujjain. Enjoy clean, air-conditioned vehicles, skilled drivers, flexible pickup points, and smooth, safe travel. Suitable for families, couples, and solo travelers looking for a relaxed long-distance journey."
  },
  {
    "name": "Non AC Cab Pune to Ujjain",
    "description": "Affordable non-AC cab service from Pune to Ujjain for budget-conscious travelers. Reliable drivers, well-maintained cars, and flexible pickup/drop points ensure safe, comfortable, and economical travel over long distances."
  },
  {
    "name": "Innova Cab Pune to Ujjain",
    "description": "Book spacious and comfortable Innova cabs from Pune to Ujjain. Ideal for families or groups, featuring AC comfort, ample legroom, luggage space, and experienced drivers. Enjoy smooth travel on highways and city roads for a stress-free journey."
  },
  {
    "name": "Ertiga Cab Pune to Ujjain",
    "description": "Affordable and convenient group travel with Ertiga cabs from Pune to Ujjain. AC/non-AC options, comfortable seating, luggage space, and professional drivers ensure a safe and enjoyable ride. Perfect for friends, families, or corporate groups."
  },
  {
    "name": "Luxury Cab Pune to Ujjain",
    "description": "Travel in style with luxury cab services from Pune to Ujjain. Premium Sedans and SUVs with elegant interiors, AC service, and professional chauffeurs make it ideal for VIP guests, business executives, or special occasions. Experience comfort, safety, and prestige throughout the journey."
  },
  {
    "name": "Affordable Cab Pune to Ujjain",
    "description": "Get pocket-friendly Pune to Ujjain cab services with transparent fares, AC/non-AC options, and professional drivers. Flexible timings, easy booking, and reliable service make it perfect for solo travelers, students, and small families looking for value-for-money travel."
  },
  {
    "name": "Pune to Ujjain Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Ujjain ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers for a hassle-free interstate journey."
  },
  {
    "name": "Pune to Ujjain One Way Cab",
    "description": "Book one-way cabs from Pune to Ujjain at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it ideal for travelers heading to Ujjain without return plans."
  },
  {
    "name": "Pune to Ujjain Drop Cab",
    "description": "One-way drop cab service from Pune to Ujjain with flexible timings, AC/non-AC options, and professional drivers. Enjoy a smooth, comfortable ride perfect for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Cab Pune to Ujjain",
    "description": "Premium corporate cab hire from Pune to Ujjain with executive vehicles, professional chauffeurs, and flexible travel schedules. Ideal for conferences, business meetings, client visits, and corporate events, offering comfort, punctuality, and reliability."
  },
  {
    "name": "Wedding Cab Pune to Ujjain",
    "description": "Elegant wedding cab service from Pune to Ujjain with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics with complete reliability and style."
  },
  {
    "name": "Online Cab Booking Pune to Ujjain",
    "description": "Book your Pune to Ujjain cab online with instant confirmation, secure payment, and transparent fares. Choose from Sedans, Innova, and Ertiga for a convenient, stress-free journey. Ideal for last-minute travel, weekend trips, or planned travel with complete convenience."
  }
],
"tableData": [
  ["Pune to Ujjain Cab Service", "Pune to Ujjain Taxi Service"],
  ["Pune to Ujjain Car Hire", "AC Cab Pune to Ujjain"],
  ["Non AC Cab Pune to Ujjain", "Innova Cab Pune to Ujjain"],
  ["Ertiga Cab Pune to Ujjain", "Luxury Cab Pune to Ujjain"],
  ["Affordable Cab Pune to Ujjain", "Pune to Ujjain Outstation Cab"],
  ["Pune to Ujjain One Way Cab", "Pune to Ujjain Drop Cab"],
  ["Online Cab Booking Pune to Ujjain", "Corporate Cab Pune to Ujjain"],
  ["Wedding Cab Pune to Ujjain", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Ujjain Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs provides comfortable and reliable cab services from Pune to Ujjain — ideal for pilgrims, family trips, and leisure journeys to the holy city."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get affordable and transparent fares for Pune to Ujjain cabs — no hidden charges, no surge pricing, ensuring full value for your money."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars according to your comfort, group size, and budget for the Pune–Ujjain route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and trained drivers are familiar with the Pune to Ujjain route, guaranteeing a safe, smooth, and punctual travel experience."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups from anywhere in Pune — airport, home, office, or railway station — and drop-offs at your preferred location in Ujjain."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "Sai Trupti Cabs maintains clean, sanitized, and regularly serviced vehicles to ensure a comfortable and reliable journey every time."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our customer support team is available 24/7 to assist with bookings, route information, or any queries for your Pune to Ujjain cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Ujjain cab easily via call, WhatsApp, or our website — get instant confirmation and enjoy a stress-free and timely travel experience."
  }
]
































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Ujjain cab services?',
    answer: 'Yes, Sai Trupti Cabs provides safe, reliable, and affordable Pune to Ujjain cab services for one way, round trips, and business or personal travel.',
  },
  {
    question: 'How can I book a Pune to Ujjain cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Ujjain cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking assistance.',
  },
  {
    question: 'What types of cabs are available from Pune to Ujjain?',
    answer: 'We offer a range of well-maintained vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers—ideal for families, groups, and solo travelers.',
  },
  {
    question: 'Are the drivers experienced for Pune to Ujjain routes?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced with the Pune–Ujjain route, ensuring a comfortable and safe travel experience.',
  },
  {
    question: 'Can I book a cab for local sightseeing in and around Ujjain?',
    answer: 'Of course! Sai Trupti Cabs offers local sightseeing packages in Ujjain for attractions like Mahakaleshwar Temple, Kal Bhairav Temple, Ram Ghat, and Bade Ganesh Temple.',
  },
  {
    question: 'Is the Pune to Ujjain cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Pune to Ujjain cab services so you can plan your trip anytime according to your convenience.',
  },
  {
    question: 'What are the Pune to Ujjain cab fares?',
    answer: 'Our Pune to Ujjain cab fares start from ₹4,500 for sedans and ₹5,500–₹6,500 for SUVs or Innova Crysta, depending on your travel plan and vehicle choice.',
  },
  {
    question: 'What payment options are available for Pune to Ujjain cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a seamless and secure transaction experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Ujjain cabs?',
    answer: 'All our cabs are sanitized before each ride, and our drivers follow strict hygiene and safety protocols to ensure a worry-free journey.',
  },
  {
    question: 'Is customer support available during the Pune to Ujjain cab journey?',
    answer: 'Yes, Sai Trupti Cabs provides round-the-clock customer support to assist you during your Pune to Ujjain trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil',
    feedback: 'Our Pune to Ujjain journey with Sai Trupti Cabs was smooth and stress-free. The cab was clean and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Meena Shinde',
    feedback: 'Excellent service for Pune to Ujjain travel. Sai Trupti Cabs ensured timely pickup, safe driving, and a comfortable ride.',
    rating: 5,
  },
];





























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Ujjain Mahakal Darshan Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-ujjain-cab.jpg",
  "description": "Sai Trupti Cabs offers Pune to Ujjain cab service for Mahakaleshwar darshan with one way taxi, round trip cabs, Innova Crysta, Ertiga, sedan and SUV options. Book long distance pilgrimage cabs with professional drivers, 24x7 service and safe, comfortable travel.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Ujjain"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "9540"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-ujjain-cab-booking",
    "itemCondition": "https://schema.org/NewCondition"
  }
};






  return (
    <div>
<Helmet>
  <title>Pune to Ujjain Cab | Mahakal Darshan Taxi ₹7999 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Ujjain cab for Mahakal darshan at ₹7999 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Safe and comfortable pilgrimage cab service." 
  />

  <meta 
    name="keywords" 
    content="pune to ujjain cab, pune to ujjain taxi, pune to ujjain cab service, mahakal darshan cab pune, pune to ujjain one way cab, pune to ujjain taxi fare, pune to ujjain innova crysta, pune to ujjain ertiga cab, pune to ujjain sedan cab, cheap pune to ujjain cab, best cab service pune to ujjain, pune to ujjain drop taxi, pune to ujjain round trip cab, ujjain mahakal cab booking pune" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/83.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoujjaincabservice;